import parse from 'date-fns/parse'
import format from 'date-fns/format'
import subYears from 'date-fns/subYears'

/**
 * Rule for legal age > 18 years old
 * @argument {Date} value
 */ 
export const legalAge = (value) => {
  if (value != '' && value != null) {
    let d1 = new Date(parse(value, 'dd/MM/yyyy', new Date()))
    let d2 = new Date(parse(format(subYears(new Date(), 18), 'dd/MM/yyyy'), 'dd/MM/yyyy', new Date()))
    return d1 <= d2
  } else {
    return true
  }
};

